export default __webpack_public_path__ + "static/media/AirCanada.07b2b161.png";